<template>
  <div class="getback-password">
    <el-dialog
      :title="isback ? '找回密码' : '修改密码'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="handleClosed"
      :modal-append-to-body="false"
    >
      <el-steps :active="active" finish-status="success" align-center>
        <el-step title="验证手机号"></el-step>
        <el-step title="信息修改"></el-step>
        <el-step title="重置"></el-step>
        <el-step title="进入数据库"></el-step>
      </el-steps>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        v-if="active == 0"
      >
        <el-form-item prop="phone" label="手机号:">
          <img src="@/assets/img/findpwd/icon.png" alt />
          <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="phoneCode" class="code" label="验证码:">
          <img src="@/assets/img/findpwd/icon2.png" alt />
          <el-input placeholder="请输入验证码" v-model="ruleForm.phoneCode"></el-input>
          <el-button
            class="get-code-btn"
            @click="getCode"
            :disabled="disabledCodeBtn"
          >{{codeButton}}</el-button>
        </el-form-item>
      </el-form>
      <div class="con" v-if="active == 1">
        <el-radio-group v-model="radio1">
          <el-radio-button label="修改用户名"></el-radio-button>
          <el-radio-button label="修改密码"></el-radio-button>
        </el-radio-group>
      </div>
      <el-form
        :model="ruleFormUser"
        :rules="rulesUser"
        ref="ruleFormUser"
        label-width="90px"
        class="demo-ruleForm"
        v-if="active == 2 && editUserFlag"
      >
        <el-form-item prop="oldUserName" label="旧用户名:">
          {{ruleFormUser.oldUserName}}
          <!-- <img src="@/assets/img/login/user.png" alt /> 
          <el-input v-model="ruleFormUser.oldUserName" placeholder="请输入旧用户名" disabled></el-input>-->
        </el-form-item>
        <el-form-item prop="newUserName" label="新用户名:">
          <img src="@/assets/img/login/user.png" alt />
          <el-input v-model="ruleFormUser.newUserName" placeholder="请输入新用户名"></el-input>
        </el-form-item>
      </el-form>
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        label-width="90px"
        class="demo-ruleForm"
        v-if="active == 2 && !editUserFlag"
      >
        <el-form-item prop="passWordFrist" label="重置密码:">
          <img src="@/assets/img/findpwd/icon2.png" alt />
          <el-input v-model="ruleForm2.passWordFrist" placeholder="请输入8-16位数字和字母"></el-input>
        </el-form-item>
        <el-form-item prop="passWordSecond" label="确认密码:">
          <img src="@/assets/img/findpwd/icon2.png" alt />
          <el-input v-model="ruleForm2.passWordSecond" placeholder="请输入8-16位数字和字母"></el-input>
        </el-form-item>
      </el-form>
      <div class="con" v-if="active == 3">
        <div class="success">
          <img src="@/assets/img/register/success.png" alt />
          <p>重置成功</p>
        </div>
      </div>
      <el-button class="nextstep" style="margin-top: 12px;" @click="next">{{text}}</el-button>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMessagePwd,
  handleCodeCheck,
  getOldUserName,
  resetUserName,
  resetPwd
} from "@/api/login";
export default {
  name: "forgetpwd",
  props: {
    pwdDialogVisible: {
      default: false,
      type: Boolean
    },
    isback: {
      type: Boolean
    }
  },
  watch: {
    active(newVal) {
      if (newVal == 3) {
        this.text = this.isback ? "登录" : "确定";
      }
    },
    pwdDialogVisible(newVal) {
      this.dialogVisible = newVal;
      this.$nextTick(() => {
        this.active = 0;
        this.radio1 = "";
        this.ruleForm = {};
        this.ruleForm2 = {};
        // this.ruleFormUser = {}
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
        this.$refs.ruleForm2 && this.$refs.ruleForm2.resetFields();
        // this.$refs.ruleFormUser && this.$refs.ruleFormUser.resetFields();
        this.text = "下一步";
        clearInterval(this.timer);
        this.num = 60;
        this.codeButton = "获取验证码";
        this.disabledCodeBtn = false;
      });
    }
  },
  data() {
    var validateTel = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (value && !myreg.test(value)) {
        callback(new Error("请正确输入手机号"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      var myreg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
      if (value === "" || !myreg2.test(value)) {
        callback(new Error("请输入8-16位数字和字母"));
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value && value !== this.ruleForm2.passWordFrist) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      codeButton: "获取验证码",
      num: 60,
      dialogVisible: false,
      text: "下一步",
      active: 0,
      radio1: "",
      editUserFlag: false,
      disabledCodeBtn: false, // 获取验证码点击
      timer: "",
      forgetMsgCode: "",
      ruleForm: {
        phone: "",
        phoneCode: ""
      },
      ruleForm2: {
        passWordFrist: "",
        passWordSecond: ""
      },
      ruleFormUser: {
        oldUserName: "",
        newUserName: ""
      },
      data: "",
      disabled: false,
      rules: {
        phone: [{ required: true, validator: validateTel, trigger: "blur" }],
        phoneCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      rules2: {
        passWordFrist: [
          { required: true, validator: validatePass, trigger: "blur" }
        ],
        passWordSecond: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ]
      },
      rulesUser: {
        // oldUserName: [
        //   { required: true, message: "请输入旧用户名", trigger: "blur" }
        // ],
        newUserName: [
          { required: true, message: "请输入新用户名", trigger: "blur" },
          { min: 0, max: 20, message: "长度在 0 到 20 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleClosed() {
      this.$emit("handleClosed", {
        closed: true
      });
    },
    //获取验证码
    async getCode() {
      if (this.num < 60) {
        return;
      }
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.ruleForm.phone) {
        this.$message({
          message: "请输入手机号",
          type: "error"
        });
        return;
      } else if (this.ruleForm.phone && !myreg.test(this.ruleForm.phone)) {
        this.$message({
          message: "请正确输入手机号",
          type: "error"
        });
        return;
      }
      let params = {
        phone: this.ruleForm.phone
      };
      let res = await getMessagePwd(params);
      if (res.status == 200) {
        this.$message({
          message: "验证码已发送",
          type: "success"
        });
        this.disabledCodeBtn = true;
        this.num = 60;
        this.timer = setInterval(() => {
          if (this.num < 2) {
            clearInterval(this.timer);
            this.disabledCodeBtn = false;
            this.codeButton = "获取验证码";
            this.num = 60;
            return;
          }
          this.num--;
          this.codeButton = this.num + "秒后重新发送";
        }, 1000);
      }
    },
    async getOldUserName() {
      let params = {
        phone: this.ruleForm.phone,
        phoneCode: this.forgetMsgCode
      };
      let res = await getOldUserName(params);
      if (res.status == 200) {
        this.ruleFormUser.oldUserName = res.data.data;
      }
    },
    next() {
      if (this.active == 0) {
        this.$refs["ruleForm"].validate(async valid => {
          if (valid) {
            let res = await handleCodeCheck(this.ruleForm);
            if (res.status == 200) {
              this.active = 1;
              this.forgetMsgCode = res.data.data;
            } else {
              // this.$message.error(res.data.data)
            }
          }
        });
      } else if (this.active == 1) {
        if (!this.radio1) {
          this.$message.error("请选择修改类型");
          return;
        }
        this.active = 2;
        if (this.radio1 == "修改用户名") {
          this.editUserFlag = true;
          // 查找旧用户名
          this.getOldUserName();
        } else {
          this.editUserFlag = false;
        }
      } else if (this.active == 2) {
        if (this.editUserFlag) {
          this.$refs["ruleFormUser"].validate(async valid => {
            if (valid) {
              let params = {
                phone: this.ruleForm.phone,
                phoneCode: this.forgetMsgCode,
                userName: this.ruleFormUser.newUserName
              };
              let res1 = await resetUserName(params);
              if (res1.status == 200) {
                this.active = 3;
              } else {
                // this.$message.error(res1.data.data)
              }
            }
          });
        } else {
          this.$refs["ruleForm2"].validate(async valid => {
            if (valid) {
              let params = {
                phone: this.ruleForm.phone,
                phoneCode: this.forgetMsgCode,
                ...this.ruleForm2
              };
              let res = await resetPwd(params);
              if (res.status == 200) {
                this.active = 3;
              } else {
                // this.$message.error(res.data.data)
              }
            }
          });
        }
      } else if (this.active == 3) {
        location.reload();
      }
    }
  },
  mounted() {}
};
</script>

<style scoped lang='scss'>
.getback-password /deep/ {
  .el-dialog {
    border-radius: 10px;
    width: 810px !important;
    height: 672px !important;
    overflow: hidden;
    position: relative;
  }
  .el-step__head.is-process {
    color: #ff854c;
    border-color: #ff854c;
  }
  .el-step__title.is-process {
    color: #ff854c;
  }
  .con {
    width: 500px;
    margin: 60px auto;
  }
  .con > div {
    margin-bottom: 30px;
    overflow: hidden;
  }
  .con .el-radio-group {
    display: block;
  }
  .con .el-radio-button {
    display: block;
    margin-bottom: 20px;
    border: none;
  }
  .con .el-radio-button__inner {
    width: 100%;
    border: 1px dashed #dcdfe6;
  }
  .con .el-radio-button__inner:hover {
    color: #ff854c;
  }
  .con .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #ff854c;
    background-color: #fff4ef;
  }
  .con input {
    width: 398px;
    height: 40px;
    float: left;
    padding-left: 20px;
  }
  .nextstep {
    width: 150px;
    height: 40px;
    background: #ff854c;
    font-size: 14px;
    color: #fff;
    display: block;
    position: absolute;
    margin-left: -75px;
    left: 50%;
    bottom: 66px;
  }
  .el-dialog__header {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 50px;
  }
  .el-dialog__title {
    font-size: 24px;
  }
  .code input {
    width: 216px;
  }
  .el-button:active {
    border-color: #ff854c;
  }
  .el-step__head.is-success {
    color: #ff854c;
    border-color: #ff854c;
  }
  .el-step__title.is-success {
    color: #ff854c;
  }
  .success img {
    display: block;
    margin: 70px auto 0;
  }
  .success p {
    text-align: center;
    font-size: 24px;
    margin-top: 20px;
    color: #000;
  }
  .el-form {
    width: 500px;
    position: relative;
    margin: 42px auto 0;
  }
  .el-form .el-input__inner {
    padding-left: 56px;
  }
  .el-form img {
    position: absolute;
    top: 8px;
    left: 10px;
    z-index: 99;
  }
  .code .el-input {
    width: 214px;
  }
  .el-form-item {
    margin-bottom: 22px !important;
  }
  .get-code-btn {
    background: #fff;
    border-color: rgb(255, 133, 76);
    color: rgb(255, 133, 76);
    margin-left: 8px;
  }
  .get-code-btn:hover {
    background: #fff;
    border-color: rgb(255, 133, 76);
    color: rgb(255, 133, 76);
    margin-left: 8px;
  }
}
</style>
